'use strict';

class UserSettings {
  constructor(userService, I18N, Notification) {
    this.userService = userService;
    this.I18N = I18N;
    this.Notification = Notification;
    this.verificationCode = '';

    this.notifications = {
      srInvoices: null,
      srDueInvoices: null,
      reallocation: null
    };

    this.user = {};
    this.multifactorAuth = {};
  }

  $onInit() {
    this.load();
  }

  load() {
    this.userService.getSettings()
      .then((resp) => {
        this.notifications = resp.data;
      });

    this.userService.get()
      .then((resp) => {
        this.user = resp.data;
      });

    this.getMultifactorAuth();
  }

  getMultifactorAuth() {
    this.userService.getMultifactorAuth()
      .then((resp) => {
      this.multifactorAuth = resp.data;
    });
  }

  regenerateMFACode() {
    this.userService.generateMFACode()
      .then((resp) => {
        this.getMultifactorAuth();
      });
  }

  disableMFA() {
    this.userService.disableMFA()
      .then((resp) => {
        this.getMultifactorAuth();
      });
  }

  forgetMFADevices() {
    this.userService.forgetMFADevices()
      .then((resp) => {
        this.getMultifactorAuth();
      });
  }

  verifyMultifactorAuth() {
    this.userService.verifyMultifactorAuth(this.verificationCode)
      .then(() => {
        this.getMultifactorAuth();
      })
      .catch((err) => this.Notification.error(err.data.endUserMessage));
  }

  enable2FA() {
    this.regenerateMFACode();
  }

  saveNotification() {
    this.userService.saveSettings(this.notifications)
      .then(() => {
        this.load();
        this.Notification.success(this.I18N.general.saved);
      })
      .catch((err) => this.Notification.error(err.data.endUserMessage));
  }
}

UserSettings.$inject = ['userService', 'I18N', 'Notification'];

const userSettings = {
  controller: UserSettings,
  template: `
    <div class="row">
      <div class="large-6 columns">
        <h2>Brukerinnstillinger</h2>
      </div>

      <div class="large-6 columns right-align">
        <a role="button" class="button secondary" href="#/konto">Konto</a>
      </div>
    </div>

    <div class="row">
      <div class="large-6 columns">
        <email-change />
      </div>
      <div class="large-6 columns">
        <password-change />
      </div>
    </div>

    <fieldset>
      <h3 class="subheader">Endre varslinger</h3>

      <label for="srInvoices">
        <input type="checkbox" id="srInvoices" ng-model="$ctrl.notifications.srInvoices" ng-click="$ctrl.saveNotification()">
        Vis beskjed om regninger for bruk av SendRegning
      </label>
      <label for="srDueInvoices">
        <input type="checkbox" id="srDueInvoices" ng-model="$ctrl.notifications.srDueInvoices" ng-click="$ctrl.saveNotification()">
        Vis advarsel om forfalte regninger for bruk av SendRegning
      </label>
      <label for="reallocation" ng-hide="!$ctrl.notifications.reallocation">
        <input type="checkbox" id="reallocation" ng-model="$ctrl.notifications.reallocation" ng-click="$ctrl.saveNotification()">
        Gi meg beskjed når <a href="/hjelp/autorydd-pa-din-sendregning-konto/" target="_blank">AutoRydd</a> flytter en innbetaling
      </label>
    </fieldset>

    <fieldset>
      <h3 class="subheader">Registrer ny konto</h3>
      <p>Lager en ny konto knyttet til din eksisterende bruker. Du vil få velge hvilken konto du skal bruke når du logger på.</p>
      <p><a href="#/konto/registrer">Registrer ny konto</a></p>
    </fieldset>
    <fieldset>
      <h3 class="subheader">SIKKERHET</h3>
      <p>Tofaktorautentisering er et ekstra sikkerhetslag ved pålogging, i tillegg til brukernavn og passord. For å logge på SendRegning-kontoen, må du oppgi en egen sikkerhetskode, som generes av en Tofaktorautentiseringsapp på telefonen.</p>
      <p>For å ta i bruk Tofaktorautentisering, må du laste ned Google Authenticator eller en annen autentiseringsapp fra Google Play eller Apple App Store.</p>
      <button class="button" ng-click="$ctrl.enable2FA()" ng-show="$ctrl.multifactorAuth.mfaCode == null">Aktiver Tofaktorautentisering</button>
      <div class="row" ng-show="$ctrl.multifactorAuth.mfaCode != null">
        <div class="large-6 columns">
            <input type="text" disabled="disabled" ng-model="$ctrl.multifactorAuth.mfaCode">
        </div>
        <div class="large-6 columns">
            <button class="button" ng-click="$ctrl.regenerateMFACode()">Generer på nytt</button>
        </div>
      </div>
      <div class="row" ng-show="$ctrl.multifactorAuth.mfaCode != null">
        <div class="large-12 columns">
            <p ng-show="!$ctrl.multifactorAuth.mfaEnabled && $ctrl.multifactorAuth.mfaCode != null">Skann QR-koden, eller skriv inn den oppgitte koden.</p>
            <img src="{{$ctrl.multifactorAuth.qrImageUrl}}">
        </div>
        <div class="large-12 columns" ng-show="!$ctrl.multifactorAuth.mfaEnabled && $ctrl.multifactorAuth.mfaCode != null">
        <p>Oppgi bekreftelseskoden du får i appen</p>
            <input type="text" name="verificationCode" ng-model="$ctrl.verificationCode" placeholder="Bekreftelseskode">
            <button class="button" ng-click="$ctrl.verifyMultifactorAuth()">Bekreft</button>
        </div>
        <div class="large-12 columns" ng-show="$ctrl.multifactorAuth.mfaEnabled">
            <button class="button" ng-click="$ctrl.disableMFA()">Deaktiver Tofaktorautentisering</button>
        </div>
        <div class="large-12 columns" ng-show="$ctrl.multifactorAuth.mfaRemembered">
            <button class="button" ng-click="$ctrl.forgetMFADevices()">Glem alle enheter</button>
        </div>
      </div>
    </fieldset>
  `
};

angular
  .module('SendRegning')
  .component('userSettings', userSettings)
  .config(($routeProvider) => {
    $routeProvider
      .when('/bruker', {
        title: 'Brukerinnstillinger',
        template: '<user-settings />',
        secure: true
      });
  });
